import axios from 'axios';
import qs from 'qs';
import {
  addBearerToken,
  displayErrorMessage,
  refreshAccessToken,
  addImpersonationHeader,
} from 'src/service/AxiosUtils';

// world rugby api
const api = axios.create({
  baseURL: process.env.API,
  timeout: 30000,
  // aws api gateway requires array parameters as value=1,2,3 (with no [])
  // which is why we have to override the default axios serializer, which uses []
  // paramsSerializer: {serialize: (params) => qs.stringify(params, {arrayFormat: 'comma', format: 'RFC1738'})}
  paramsSerializer: {
    serialize: (params) =>
      qs.stringify(params, { arrayFormat: 'comma', encodeValuesOnly: true }),
  },
});

api.interceptors.request.use(addBearerToken);
api.interceptors.request.use(addImpersonationHeader);
api.interceptors.response.use((response) => response, refreshAccessToken);
api.interceptors.response.use((response) => response, displayErrorMessage);

// s3 for file uploads
const s3api = axios.create({ timeout: 20000 });
// s3api will throw exceptions unless we add the response interceptor. But we need to poll for files with 401 responses so have to allow for it
// s3api.interceptors.response.use(response => response, displayErrorMessage);

export { api, s3api };
